/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file EventTypes.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

export const TRACK_CLICK = 'TRACK_CLICK'



// WEBPACK FOOTER //
// ./webpack/js/types/EventTypes.js